import { render, staticRenderFns } from "./teachingLevel.vue?vue&type=template&id=0b24dfa6&scoped=true&"
import script from "./teachingLevel.vue?vue&type=script&lang=js&"
export * from "./teachingLevel.vue?vue&type=script&lang=js&"
import style0 from "./teachingLevel.vue?vue&type=style&index=0&id=0b24dfa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24dfa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VProgressCircular,VRow})
